var map = {
	"./barrel.webp": 634,
	"./bone.webp": 824,
	"./brain.webp": 630,
	"./dna.webp": 355,
	"./eyeball.webp": 542,
	"./flask.webp": 361,
	"./gasmask.webp": 899,
	"./hand.webp": 363,
	"./heart.webp": 302,
	"./meat.webp": 925,
	"./radiation.webp": 25,
	"./skull.webp": 27,
	"./spider.webp": 567,
	"./tombstone.webp": 945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 886;